// import { CIRCUIT_TYPES_BY_NAME } from '../../circuit-types';

import {
  getObjectAtSystemDefinitionSlot,
} from '../../project-definition-data-access';

import {
  CIRCUIT_TYPES_BY_NAME,
} from '../../circuit-types';

import { instantiate as defaultInstantiate } from '../defaults';

// ////////////////////////////////////////////////////////////////
//
// Internal functions
//
// ////////////////////////////////////////////////////////////////

function translateCircuit(circuit) {
  if (circuit === 'gemengd') {
    return 'mixed';
  }
  return circuit;
}

function createInstance(product, type, systemDefinition, systemProducts, basedOnObject) {
  if (!product) {
    return null;
  }
  const result = defaultInstantiate(product, type, systemDefinition, systemProducts, basedOnObject);
  if (!result) {
    return null;
  }
  result.property = product.set_identifier;

  return result;
}

function findHydraulicsProductInfo(hydraulicsItem, systemProducts) {
  if (!systemProducts) {
    return null;
  }
  const { attributes } = systemProducts;
  if (!attributes) {
    return null;
  }

  let hydraulicsID = hydraulicsItem;
  let hydraulicsSetIdentifier = null;
  if (hydraulicsItem && typeof (hydraulicsItem) === 'object') {
    hydraulicsID = hydraulicsItem.id;
    hydraulicsSetIdentifier = hydraulicsItem.property;
  }
  const hydraulicsIDString = `${hydraulicsID}`;

  const { sets } = systemProducts.attributes;
  const numSets = sets ? Object.keys(sets).length : 0;
  for (let i = 0; i < numSets; i += 1) {
    const name = `hydraulics-${i + 1}`;
    const array = sets[name];
    if (array) {
      for (let j = 0, length = array.length; j < length; j += 1) {
        const hydraulicsProduct = array[j];
        const hydraulicsProductID = `${hydraulicsProduct.id}`;
        const hydraulicsProductSetID = `${hydraulicsProduct.set_identifier}`;
        if (hydraulicsProductID === hydraulicsIDString && hydraulicsSetIdentifier === hydraulicsProductSetID) {
          return hydraulicsProduct;
        }
      }
    }
  }

  const { hydraulics } = attributes;
  if (!hydraulics) {
    return null;
  }

  for (let i = 0, length = hydraulics.length; i < length; i += 1) {
    const product = hydraulics[i];
    const productId = `${product.id}`;
    if (productId === hydraulicsIDString) {
      return product;
    }
  }
  return null;
}

function findProductInfoBySlotName(slotName, systemDefinition, systemProducts) {
  const data = getObjectAtSystemDefinitionSlot(slotName, systemDefinition);
  if (!data) {
    return null;
  }
  return findHydraulicsProductInfo(data, systemProducts);
}

function compareCircuitData(circuit1, circuit2) {
  if (circuit1 === circuit2) {
    return 0;
  }
  const hp1 = circuit1.hydraulicsProduct;
  const hp2 = circuit2.hydraulicsProduct;
  const hc1 = hp1 ? hp1.circuit : null;
  const hc2 = hp2 ? hp2.circuit : null;

  const h1 = circuit1.hydraulics;
  const h2 = circuit2.hydraulics;
  if (h1 === h2) {
    return 0;
  }
  if (!h1 && !h2) {
    return 0;
  }

  if (hc1 === 'double') {
    return -1;
  }
  if (hc2 === 'double') {
    return 1;
  }

  if (!h1) {
    return 1;
  }
  return -1;
}

function sortCircuits(circuitMap) {
  if (!circuitMap) {
    return;
  }
  Object.keys(circuitMap).forEach((key) => {
    const circuitData = circuitMap[key];
    if (circuitData && circuitData.circuits) {
      const { circuits: circArr } = circuitData;
      if (circArr) {
        circArr.sort(compareCircuitData);
      }
    }
  });
}

function getHydraulicsPerCircuit(systemDefinition, systemProducts) {
  const circuitMap = {};
  const { circuits } = systemDefinition.attributes;
  const numCircuits = circuits ? circuits.length : 0;
  for (let i = 0; i < numCircuits; i += 1) {
    const circuitData = circuits[i];
    const circuitAmount = circuitData.amount;
    const circuitType = translateCircuit(circuitData.type);

    const circuitTypeObject = circuitData.type ? CIRCUIT_TYPES_BY_NAME[circuitData.type] : null;
    if (circuitTypeObject && circuitTypeObject.extern !== false) {
      const circuitInfo = circuitMap[circuitType] || {};
      circuitMap[circuitType] = circuitInfo;

      const arr = circuitInfo.circuits || [];
      circuitInfo.circuits = arr;
      circuitInfo.index = 0;
      circuitInfo.type = circuitType;
      for (let j = 0; j < circuitAmount; j += 1) {
        arr.push({
          hydraulics: null,
          hydraulicsSlot: null,
          hydraulicsProduct: null,
          type: circuitData.type,
        });
      }
    }
  }

  const { slots } = systemDefinition.attributes;
  const numSlots = Object.keys(slots).length;
  for (let i = 0; i < numSlots; i += 1) {
    const slotName = `hydraulics-${i + 1}`;
    const slotValue = slots[slotName];
    if (slotValue) {
      const prod = findProductInfoBySlotName(slotName, systemDefinition, systemProducts);
      if (prod) {
        const prodCircuit = prod.circuit;
        if (prodCircuit === 'double') {
          const { direct, mixed } = circuitMap;
          if (direct && mixed) {
            const directCircuits = direct.circuits;
            const directIndex = direct.index;
            const mixedCircuits = mixed.circuits;
            const mixedIndex = mixed.index;

            direct.index += 1;
            mixed.index += 1;
            // Set double on first direct and first mixed
            const directCircuit = directCircuits[directIndex];
            const mixedCircuit = mixedCircuits[mixedIndex];

            directCircuit.hydraulicsSlot = slotName;
            directCircuit.hydraulics = slotValue;
            directCircuit.hydraulicsProduct = prod;

            mixedCircuit.hydraulicsSlot = slotName;
            mixedCircuit.hydraulics = slotValue;
            mixedCircuit.hydraulicsProduct = prod;
            break;
          }
        }
      }
    }
  }

  for (let i = 0; i < numSlots; i += 1) {
    const slotName = `hydraulics-${i + 1}`;
    const slotValue = slots[slotName];
    if (slotValue) {
      const prod = findProductInfoBySlotName(slotName, systemDefinition, systemProducts);

      // #if DEBUG
      if (!prod) {
        console.warn('Hydraulics found without product', slotName, systemDefinition, systemProducts);
      }
      // #endif

      if (prod) {
        const prodCircuit = translateCircuit(prod.circuit);
        if (prodCircuit !== 'double') {
          const circuitgroup = circuitMap[prodCircuit];
          if (circuitgroup) {
            const { circuits: circArray, index } = circuitgroup;
            const circ = circArray[index];
            circuitgroup.index += 1;
            circ.hydraulics = slotValue;
            circ.hydraulicsProduct = prod;
            circ.hydraulicsSlot = slotName;
          }
        }
      }
    }
  }
  sortCircuits(circuitMap);

  return circuitMap;
}

function addHydraulicsProductToCircuits(product, hydraulicsPerCircuit, type, systemDefinition, systemProducts) {
  const value = createInstance(product, type, systemDefinition, systemProducts);
  const { amount } = product;
  const circuit = translateCircuit(product.circuit);
  if (circuit === 'double') {
    const { direct, mixed } = hydraulicsPerCircuit;
    if (direct && mixed) {
      const directCircuits = direct.circuits;
      const mixedCircuits = mixed.circuits;

      let lastDirectCircuit = null;
      let lastDirectCircuitIndex = -1;

      for (let i = directCircuits.length - 1; !lastDirectCircuit && i >= 0; i -= 0) {
        const circuitValue = directCircuits[i];
        if (circuitValue && !circuitValue.hydraulics) {
          lastDirectCircuit = circuitValue;
          lastDirectCircuitIndex = i;
        }
      }

      let lastMixedCircuit = null;
      let lastMixedCircuitIndex = -1;

      for (let i = mixedCircuits.length - 1; !lastMixedCircuit && i >= 0; i -= 0) {
        const circuitValue = mixedCircuits[i];
        if (circuitValue && !circuitValue.hydraulics) {
          lastMixedCircuit = circuitValue;
          lastMixedCircuitIndex = i;
        }
      }
      if (lastDirectCircuit && lastMixedCircuit) {
        directCircuits.splice(lastDirectCircuitIndex, 1);
        mixedCircuits.splice(lastMixedCircuitIndex, 1);
        directCircuits.unshift(lastDirectCircuit);
        mixedCircuits.unshift(lastMixedCircuit);
        lastDirectCircuit.hydraulics = value;
      }
    }
  } else {
    const circuitData = hydraulicsPerCircuit[circuit];
    const { circuits } = circuitData;
    for (let i = 0; i < amount; i += 1) {
      const { index } = circuitData;
      const circuitObj = circuits[index] || {};
      circuits[index] = circuitObj;
      circuitObj.hydraulics = value;

      circuitData.index = index + 1;
    }
  }
}

// Apply internal hydraulics/circuits data to system definition
function applyHydraulicsPerCircuitToSystemDefinition(hydraulicsPerCircuit, systemDefinition, systemProducts) {
  const { direct, mixed } = hydraulicsPerCircuit;
  const directCircuits = direct ? direct.circuits : null;
  const mixedCircuits = mixed ? mixed.circuits : null;
  const numDirect = directCircuits ? directCircuits.length : 0;
  const numMixed = mixedCircuits ? mixedCircuits.length : 0;
  let hydrIndex = 0;
  const { slots } = systemDefinition.attributes;
  for (let i = 0; i < numDirect; i += 1) {
    const slotName = `hydraulics-${hydrIndex + 1}`;
    const slotValue = slots[slotName];
    if (typeof (slotValue) !== 'undefined') {
      const directCircuit = directCircuits[i];
      const hydraulics = directCircuit ? directCircuit.hydraulics || false : false;
      slots[slotName] = hydraulics;
      hydrIndex += 1;
    }
  }

  for (let i = 0; i < numMixed; i += 1) {
    const slotName = `hydraulics-${hydrIndex + 1}`;
    const slotValue = slots[slotName];
    if (typeof (slotValue) !== 'undefined') {
      const mixedCircuit = mixedCircuits[i];
      const hydraulics = mixedCircuit ? mixedCircuit.hydraulics || false : false;
      if (hydraulics) {
        const product = findHydraulicsProductInfo(hydraulics, systemProducts);
        const productCircuit = product ? product.circuit : null;
        if (productCircuit && productCircuit !== 'double') {
          slots[slotName] = hydraulics;
          hydrIndex += 1;
        }
      }
    }
  }
  // Set rest of the hydraulics slots to false
  const numSlots = Object.keys(slots).length;
  for (let i = hydrIndex; i < numSlots; i += 1) {
    const slotName = `hydraulics-${i + 1}`;
    const slotValue = slots[slotName];
    if (typeof (slotValue) !== 'undefined') {
      slots[slotName] = false;
    }
  }
}

function removeHydraulicsFromCircuit(hydraulicsProduct, circuit, hydraulicsPerCircuit) {
  const { amount, required, set_identifier, id } = hydraulicsProduct;
  let counter = amount;
  let result = false;
  const circuitData = hydraulicsPerCircuit[circuit];
  const { circuits } = circuitData;
  for (let i = 0, length = circuits.length; i < length; i += 1) {
    const circuitInfo = circuits[i];
    const circuitHydraulicsProduct = circuitInfo.hydraulicsProduct;
    if (circuitHydraulicsProduct &&
      circuitHydraulicsProduct.id === id &&
      circuitHydraulicsProduct.amount === amount &&
      circuitHydraulicsProduct.required === required &&
      circuitHydraulicsProduct.set_identifier === set_identifier &&
      counter > 0
    ) {
      circuitInfo.hydraulics = null;
      circuitInfo.hydraulicsSlot = null;
      circuitInfo.hydraulicsProduct = null;
      counter -= 1;
      result = true;
    }
  }
  return result;
}

function findHydraulicsIndexByProduct(hydraulicsProduct, circuit, hydraulicsPerCircuit) {
  const { amount, required, set_identifier, id } = hydraulicsProduct;
  const circuitData = hydraulicsPerCircuit[circuit];
  const { circuits } = circuitData;
  for (let i = 0, length = circuits.length; i < length; i += 1) {
    const circuitInfo = circuits[i];
    const circuitHydraulicsProduct = circuitInfo.hydraulicsProduct;
    if (circuitHydraulicsProduct &&
      circuitHydraulicsProduct.id === id &&
      circuitHydraulicsProduct.amount === amount &&
      circuitHydraulicsProduct.required === required &&
      circuitHydraulicsProduct.set_identifier === set_identifier
    ) {
      return i;
    }
  }
  return -1;
}

// ////////////////////////////////////////////////////////////////
//
// Export functions
//
// ////////////////////////////////////////////////////////////////

export function instantiate(product, type, systemDefinition, systemProducts, basedOnObject) {
  return createInstance(product, type, systemDefinition, systemProducts, basedOnObject);
}

export function getProductInfoBySlotName(slotName, systemDefinition, systemProducts) {
  return findProductInfoBySlotName(slotName, systemDefinition, systemProducts);
}

export function canRemoveHydraulicsFromSystemDefinition(slot, systemDefinition, systemProducts) {
  const data = systemDefinition.attributes.slots[slot];
  const productInfo = findHydraulicsProductInfo(data.id, systemProducts);
  if (!productInfo) {
    return true;
  }
  const { required } = productInfo;
  return !!required;
}

/*
export function canAddAnyProductToSystemDefinitionOLD(hydraulicsProduct, systemDefinition, systemProducts) { // eslint-disable-line
  let hydraulicsProductInfo = hydraulicsProduct;
  if (typeof (hydraulicsProduct) === 'number' || typeof (hydraulicsProduct) === 'string') {
    hydraulicsProductInfo = findHydraulicsProductInfo(hydraulicsProduct, systemProducts);
  }
  if (!hydraulicsProductInfo) {
    return false;
  }
  const { circuit } = hydraulicsProductInfo;
  const { circuits, slots } = systemDefinition.attributes;

  const isCircuitDirect = circuit === 'direct';
  const isCircuitDouble = circuit === 'double';
  if (!circuits) {
    return false;
  }

  // Unroll circuits
  const availableCircuits = [];
  let circuitIndex = 0;
  circuits.forEach((c) => {
    const { type, amount } = c;
    const typeObject = CIRCUIT_TYPES_BY_NAME[type];

    const typeObjectExtern = typeObject.extern;

    // - Also Filter out 'intern' circuits, because hydraulics items can't be placed on intern circuits
    if (typeObjectExtern) {
      for (let i = 0; i < amount; i += 1) {
        availableCircuits.push({
          index: circuitIndex,
          type: typeObject,
        });
        circuitIndex += 1;
      }
    }
  });
  const numCircuits = availableCircuits.length;
  if (!numCircuits) {
    return false;
  }

  const numSlots = Object.keys(slots).length;

  const findDirectCircuitFunc = (c) => {
    return c.type.direct;
  };
  const findMixedCircuitFunc = (c) => {
    return !c.type.direct;
  };
  const removeCircuitType = (type) => {
    if (type === 'double') {
      for (let i = 0; i < numCircuits; i += 1) {
        const availableCircuit = availableCircuits[i];
        if (availableCircuit.type.direct && availableCircuit.type.extern) {
          const secondAvailableCircuit = availableCircuits[i + 1];
          if (!secondAvailableCircuit || (!secondAvailableCircuit.type.direct && secondAvailableCircuit.type.extern)) {
            // First two circuits are occupied by one double hydraulics item
            availableCircuits.shift();
            availableCircuits.shift();
            break;
          }
        }
      }
    } else {
      const func = (type === 'direct') ? findDirectCircuitFunc : findMixedCircuitFunc;
      const index = availableCircuits.findIndex(func);
      if (index >= 0) {
        availableCircuits.splice(index, 1);
      }
    }
  };

  // Remove all circuits used by hydraulics
  for (let i = 0; i < numSlots; i += 1) {
    let name = `hydraulics-${i + 1}`;
    let hydraulicsData = slots[name];
    if (!hydraulicsData) {
      name = `hydraulics_${i + 1}`;
      hydraulicsData = slots[name];
    }
    if (hydraulicsData) {
      const product = findHydraulicsProductInfo(hydraulicsData.id, systemProducts);
      removeCircuitType(product.circuit);
    }
  }

  const numAvailable = availableCircuits ? availableCircuits.length : 0;
  if (!numAvailable) {
    return false;
  }

  if (isCircuitDouble) {
    if (numAvailable > 1) {
      // New hydraulics item is a double one, can only be placed on a direct and a mixed circuit
      return availableCircuits[0].type.direct && !availableCircuits[1].type.direct;
    }
    return false;
  }
  for (let i = 0; i < numAvailable; i += 1) {
    const availableCircuit = availableCircuits[i];
    if (availableCircuit.type.direct === isCircuitDirect) {
      return true;
    }
  }

  return false;
}

*/

export function canRemoveProductFromSystemDefinition(slot, systemDefinition, systemProducts, productInfo) { // eslint-disable-line
  const data = systemDefinition.attributes.slots[slot];
  const prodInf = productInfo || findHydraulicsProductInfo(data.id, systemProducts);
  if (!prodInf) {
    return true;
  }
  return !prodInf.required;
}

export function addProductToSystemDefinition(type, product, systemDefinition, systemProducts) { // eslint-disable-line
  if (!product) {
    return false;
  }
  const hydraulicsPerCircuit = getHydraulicsPerCircuit(systemDefinition, systemProducts);

  addHydraulicsProductToCircuits(product, hydraulicsPerCircuit, type, systemDefinition, systemProducts);
  sortCircuits(hydraulicsPerCircuit);
  applyHydraulicsPerCircuitToSystemDefinition(hydraulicsPerCircuit, systemDefinition, systemProducts);
}

export function replaceProductInSystemDefinition(slotName, systemDefinition, systemProducts, product) { // eslint-disable-line
  const hydraulicsObject = getObjectAtSystemDefinitionSlot(slotName, systemDefinition, systemProducts);
  if (!hydraulicsObject) {
    return false;
  }
  const hydraulicsProduct = getProductInfoBySlotName(slotName, systemDefinition, systemProducts);
  if (!hydraulicsProduct) {
    return false;
  }
  // Find all hydraulics from the same set
  // Set all hydraulics of the same set to null
  const hydraulicsPerCircuit = getHydraulicsPerCircuit(systemDefinition, systemProducts);
  const circuit = translateCircuit(hydraulicsProduct ? hydraulicsProduct.circuit : null);
  const realCircuitType = circuit === 'double' ? 'direct' : circuit;

  const newCircuit = translateCircuit(product ? product.circuit : null);
  const newAmount = product ? product.amount : 0;

  let hydraulicsIndexOfCircuits = findHydraulicsIndexByProduct(hydraulicsProduct, realCircuitType, hydraulicsPerCircuit) || 0;
  if (hydraulicsIndexOfCircuits < 0) {
    hydraulicsIndexOfCircuits = 0;
  }

  let result = false;
  if (circuit === 'double') {
    result = removeHydraulicsFromCircuit(hydraulicsProduct, 'direct', hydraulicsPerCircuit) || result;
    result = removeHydraulicsFromCircuit(hydraulicsProduct, 'mixed', hydraulicsPerCircuit) || result;
  } else {
    result = removeHydraulicsFromCircuit(hydraulicsProduct, circuit, hydraulicsPerCircuit) || result;
  }
  if (!result) {
    // Failed - could not remove old data
    // #if DEBUG
    console.warn('Replace hydraulics failed: could not remove original data');
    // #endif
    return false;
  }
  sortCircuits(hydraulicsPerCircuit);

  // Count if enough space available for new product
  const counts = {};
  Object.keys(hydraulicsPerCircuit).forEach((circuitName) => {
    counts[circuitName] = counts[circuitName] || 0;
    const circuitData = hydraulicsPerCircuit[circuitName];
    const { circuits } = circuitData;
    const numCircuits = circuits ? circuits.length : 0;
    for (let i = 0; i < numCircuits; i += 1) {
      const c = circuits[i];
      if (!c.hydraulics) {
        counts[circuitName] += 1;
      }
    }
  });
  // Add new hydraulics to system
  if (circuit === 'double') {
    if (counts.direct <= 0 || counts.mixed <= 0) {
      // No available place on direct or mixed circuit
      // #if DEBUG
      console.warn('Replace hydraulics failed: No direct or mixed circuit available for double');
      // #endif
      return false;
    }
  } else if (counts[circuit] <= 0) {
    // No available place on direct or mixed circuit
    // #if DEBUG
    console.warn('Replace hydraulics failed: No direct or mixed circuit available');
    // #endif
    return false;
  }

  const inst = createInstance(product);
  let success = false;
  if (newCircuit === 'double') {
    const directCircuitData = hydraulicsPerCircuit.direct;
    const directCircuits = directCircuitData ? directCircuitData.circuits : null;

    const mixedCircuitData = hydraulicsPerCircuit.mixed;
    const mixedCircuits = mixedCircuitData ? mixedCircuitData.circuits : null;

    const lastDirect = directCircuits ? directCircuits.pop() : null;
    if (lastDirect) {
      lastDirect.hydraulicsProduct = product;
      lastDirect.hydraulics = inst;
      directCircuits.unshift(lastDirect);
    }

    const lastMixed = mixedCircuits ? mixedCircuits.pop() : null;
    if (lastMixed) {
      lastMixed.hydraulicsProduct = product;
      lastMixed.hydraulics = inst;
      mixedCircuits.unshift(lastMixed);
    }
    success = true;
  } else {
    const circuitData = hydraulicsPerCircuit[newCircuit];
    const { circuits } = circuitData;
    const numCircuits = circuits.length;
    if (numCircuits >= newAmount) {
      // Collect all empty circuits
      const empties = [];
      for (let i = circuits.length - 1; i >= 0; i -= 1) {
        const c = circuits[i];
        if (c && !c.hydraulics) {
          empties.push(c);
        }
      }
      if (empties.length < newAmount) {
        // #if DEBUG
        console.warn('Replace hydraulics failed: not enough free circuits available', { empties, newAmount, newCircuit });
        // #endif
        return false;
      }
      for (let i = 0; i < newAmount; i += 1) {
        const offset = hydraulicsIndexOfCircuits + i;
        const empty = empties.pop();
        const index = circuits.indexOf(empty, 0);
        if (index >= 0) {
          circuits.splice(index, 1);
        }
        empty.hydraulics = inst;
        empty.hydraulicsProduct = product;
        circuits.splice(offset, 0, empty);
        success = true;
      }
    }
  }
  if (success) {
    applyHydraulicsPerCircuitToSystemDefinition(hydraulicsPerCircuit, systemDefinition, systemProducts);
  }
}

export function removeProductFromSystemDefinition(slotName, systemDefinition, systemProducts) { // eslint-disable-line
  const hydraulicsObject = getObjectAtSystemDefinitionSlot(slotName, systemDefinition);
  if (!hydraulicsObject) {
    return false;
  }
  const { slots } = systemDefinition.attributes;
  const hydraulicsProduct = getProductInfoBySlotName(slotName, systemDefinition, systemProducts);
  if (!hydraulicsProduct) {
    slots[slotName] = false;
    return true;
  }
  let result = false;
  const circuit = translateCircuit(hydraulicsProduct.circuit);
  const hydraulicsPerCircuit = getHydraulicsPerCircuit(systemDefinition, systemProducts);
  if (circuit === 'double') {
    result = removeHydraulicsFromCircuit(hydraulicsProduct, 'direct', hydraulicsPerCircuit) || result;
    result = removeHydraulicsFromCircuit(hydraulicsProduct, 'mixed', hydraulicsPerCircuit) || result;
  } else {
    result = removeHydraulicsFromCircuit(hydraulicsProduct, circuit, hydraulicsPerCircuit);
  }
  if (result) {
    applyHydraulicsPerCircuitToSystemDefinition(hydraulicsPerCircuit, systemDefinition, systemProducts);
  }
  return result;
}

function getSetName(value) {
  if (!value) {
    return null;
  }
  const setIdentifier = value.set_identifier;
  if (setIdentifier) {
    const index = setIdentifier.indexOf('.');
    if (index < 0) {
      return setIdentifier;
    }
    return setIdentifier.substring(0, index);
  }
  return null;
}

export function getAvailableNewProductsForSystemDefinition(systemDefinition, systemProducts) { // eslint-disable-line
  const result = [];
  const { slots } = systemDefinition.attributes;
  const counts = {};
  const maxcounts = {};
  const usedProductsBySet = {};

  // Count the max amount of circuits per type
  const { circuits } = systemDefinition.attributes;
  if (circuits) {
    const numCircuits = circuits.length;
    for (let i = 0; i < numCircuits; i += 1) {
      const circuit = circuits[i];
      const circuitType = translateCircuit(circuit ? circuit.type : null);
      const circuitAmount = circuit ? circuit.amount || 0 : 0;
      if (circuitType) {
        maxcounts[circuitType] = maxcounts[circuitType] || 0;
        maxcounts[circuitType] += circuitAmount;
      }
    }
  }

  // Count the used circuits
  if (slots) {
    const numSlots = Object.keys(slots).length;
    for (let i = 0; i < numSlots; i += 1) {
      const slotName = `hydraulics-${i + 1}`;
      const slotValue = slots[slotName];
      if (slotValue) {
        const product = getProductInfoBySlotName(slotName, systemDefinition, systemProducts);
        const setName = getSetName(product);
        usedProductsBySet[setName] = true;
        if (product) {
          const circuit = translateCircuit(product.circuit);
          if (circuit === 'double') {
            counts.direct = counts.direct || 0;
            counts.mixed = counts.mixed || 0;
            counts.direct += 1;
            counts.mixed += 1;
          } else {
            counts[circuit] = counts[circuit] || 0;
            counts[circuit] += 1;
          }
        }
      }
    }
  }

  // Select the available hydraulics
  const { sets } = systemProducts.attributes;
  const numSets = Object.keys(sets).length;
  for (let i = 0; i < numSets; i += 1) {
    const setName = `hydraulics-${i + 1}`;
    if (setName) {
      const setObj = sets[setName];
      if (setObj) {
        const numItems = setObj.length;
        for (let j = 0; j < numItems; j += 1) {
          const product = setObj[j];
          // Products to be added should not be required (in that case you wouldn't be able to delete them)
          if (product && !product.required) {
            // New products should not be added if there's already a product from that set added in the system definition
            if (!usedProductsBySet[setName]) {
              const { amount } = product;
              const circuit = translateCircuit(product.circuit);

              let isAvailable = false;
              if (circuit === 'double') {
                const maxDir = maxcounts.direct || 0;
                const maxMix = maxcounts.mixed || 0;
                const cntDir = counts.direct || 0;
                const cntMix = counts.mixed || 0;
                const availableDir = maxDir - cntDir;
                const availableMix = maxMix - cntMix;
                isAvailable = (availableDir > 0 && availableMix > 0);
              } else {
                const max = maxcounts[circuit] || 0;
                const used = counts[circuit] || 0;
                const available = max - used;
                isAvailable = (available > (amount - 1));
              }
              if (isAvailable) {
                result.push(product);
              }
            }
          }
        }
      }
    }
  }

  return result;
}

export function getAvailableReplacementProductsForSystemDefinition(slotName, systemDefinition, systemProducts) { // eslint-disable-line
  if (!systemDefinition || !systemProducts || !slotName) {
    return null;
  }
  const { slots } = systemDefinition.attributes;
  const hydrPerCirc = getHydraulicsPerCircuit(systemDefinition, systemProducts);

  const productInfo = findProductInfoBySlotName(slotName, systemDefinition, systemProducts);
  const slotValue = slots[slotName];
  const circuitType = translateCircuit(productInfo.circuit);
  // If you want to replace a double (over direct & mixed),
  // choose all available hydraulics with circuit === 'double' or circuit === 'direct'
  const realCircuitType = circuitType === 'double' ? 'direct' : circuitType;
  const required = !!productInfo.required;
  const circuitInfo = hydrPerCirc[realCircuitType];
  const circuits = circuitInfo ? circuitInfo.circuits : null;
  const numCircuits = circuits ? circuits.length : 0;
  let availableCircuits = numCircuits;
  for (let i = 0; i < numCircuits; i += 1) {
    const circ = circuits[i];
    if (circ.hydraulics && circ.hydraulics !== slotValue) {
      availableCircuits -= 1;
    }
  }
  if (!availableCircuits) {
    return [];
  }

  const result = [];
  const setName = getSetName(productInfo);
  const { sets } = systemProducts.attributes;
  const hydraulicsSet = sets[setName];
  const num = hydraulicsSet ? hydraulicsSet.length : 0;
  for (let i = 0; i < num; i += 1) {
    const hydrProduct = hydraulicsSet[i];
    const hydrRequired = !!hydrProduct.required;
    const hydrCircuitType = hydrProduct.circuit;
    const hydrRealCircuitType = hydrCircuitType === 'double' ? 'direct' : hydrCircuitType;
    if (
      hydrProduct !== productInfo &&
      hydrRequired === required &&
      hydrRealCircuitType === realCircuitType
    ) {
      const hydrAmount = hydrProduct.amount;
      if (hydrAmount <= availableCircuits) {
        result.push(hydrProduct);
      }
    }
  }
  return result;
}

export function canReplaceProductInSystemDefinition(slotName, systemDefinition, systemProducts, product) { // eslint-disable-line
  const arr = getAvailableReplacementProductsForSystemDefinition(slotName, systemDefinition, systemProducts);
  const num = arr ? arr.length : 0;
  return num > 0;
}

/**
 * @function canAddProductToSystemDefinition
 * @param {object|string|number} hydraulicsProduct - id or product info object
 * @param {object} systemDefinition - system definition object
 * @param {object} systemProducts - system products object
 * */
export function canAddAnyProductToSystemDefinition(type, systemDefinition, systemProducts) {
  // Reusing function 'getAvailableNewProductsForSystemDefinition'...I'm sooo lazy
  const allowedNewProducts = getAvailableNewProductsForSystemDefinition(systemDefinition, systemProducts);
  return allowedNewProducts ? allowedNewProducts.length > 0 : false;
}

// #if DEBUG
// -- tests
export function testCanAddHydraulics() {
  const hydraulicsProduct = 3;
  const systemDefinition = {
    attributes: {
      circuits: [
        {
          type: 'direct',
          amount: 1,
        },
        {
          type: 'gemengd',
          amount: 2,
        },
      ],
      slots: {
        'hydraulics-1': { id: 2 },
        'hydraulics-2': null,
        'hydraulics-3': null,
      },
    },
  };
  const systemProducts = {
    attributes: {
      hydraulics: [
        {
          id: 1,
          circuit: 'direct',
        },
        {
          id: 2,
          circuit: 'gemengd',
        },
        {
          id: 3,
          circuit: 'double',
        },
      ],
    },
  };

  const result = canAddHydraulics(hydraulicsProduct, systemDefinition, systemProducts); // eslint-disable-line
  // TODO: work in progress
}
// #if DEBUG
// TODO: remove test
window.testCanAddHydraulics = testCanAddHydraulics;
// #endif
// #endif



// WEBPACK FOOTER //
// ./js/utils/project-definition/component/hydraulics/index.js